var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.2781C1 14.7911 1.79788 14.4123 3.09003 13.7193C3.8526 13.3151 4.69991 12.9902 5.61077 12.7809C5.58959 12.5788 5.5684 12.2972 5.52604 11.9002C5.50485 11.727 5.406 11.5826 5.27185 11.4887C3.50662 10.3193 2.43336 8.16815 2.79347 5.79321C3.05472 4.06072 4.1421 2.53036 5.65313 1.69299C6.55693 1.18047 7.4466 1 8.29391 1C9.14122 1 10.0309 1.18047 10.9417 1.68577C12.4528 2.52314 13.5402 4.0535 13.8014 5.78599C14.1615 8.16093 13.0812 10.3121 11.323 11.4815C11.1818 11.5754 11.083 11.727 11.0688 11.893C11.0265 12.2972 10.9982 12.5788 10.9841 12.7737C11.895 12.9902 12.7423 13.3079 13.5049 13.7121C14.797 14.3979 15.5949 14.7839 15.5949 16.2709",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71582 6.75329C2.71582 6.75329 8.29393 5.57665 8.29393 1",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8721 6.75329C13.8721 6.75329 8.29395 5.57665 8.29395 1",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61084 12.7734C5.61084 12.7734 8.31516 14.5492 10.843 12.7734",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33105 6.59473V7.627",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2568 6.59473V7.627",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/AvatarIcon.c2093e700f4cc7d80335d9eb96550529.svg";
export { ForwardRef as ReactComponent };